/*
 * @Name 跳转events 去登录及注销公共方法（登录多个位置用到，统一一个位置维护）
 */
import config from '@/config'
import { __replaceDotCom } from '@/utils/tools'
export default {
    login() {
        let currHost = window.location.href
        let loginHost = 'https://uniportal-beta.huawei.com/uniportal1/login-pc.html' // 测试环境
        if (process.env.VUE_APP_BUILD_ENV === 'prod') {
            loginHost = 'https://uniportal.huawei.com/uniportal1/login-pc.html' // 生产环境
        }
        loginHost = __replaceDotCom(loginHost)
        currHost = encodeURIComponent(currHost)
        window.location.href = `${loginHost}?redirect=${currHost}`
    },
    logout() {
        let gateway = __replaceDotCom(config.gateway.MsaGatewayAddress, true)
        let currHost = window.location.href
        let logoutHost = gateway + 'com.huawei.it.mbs.eventsgo:eventsgomedia/eventsgo/media/servlet/logout'
        currHost = encodeURIComponent(currHost)
        window.location.href = `${logoutHost}?redirect=${currHost}`
        return new Promise(() => {})
    }
}
